import axios from 'axios';

import { HttpMethod } from './constants';

const { API_URL } = process.env;

const CSRF_TOKEN = document.querySelector('meta[name=csrf-token]').content;
const baseHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-CSRF-Token': CSRF_TOKEN,
};

if (process.env.RAILS_ENV === 'staging') {
  baseHeaders.Authorization = `Basic ${process.env.STAGING_AUTH_TOKEN}`;
}

const API = axios.create({
  baseURL: API_URL,
  timeout: 20000,
});

export class HttpService {
  constructor() {
    API.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          error.response
          && (error.response.status === 401 || error.response.status === 403)
        ) {
          this.delete('/users/sign_out')
            .then(() => {
              window.location.assign('/users/sign_in');
            });
        }
        return Promise.reject(error);
      },
    );
  }

  authHeaders = (token) => baseHeaders.append('Authorization', `Bearer ${token}`);
  buildHeaders = (token, contentType) => {
    if (token) {
      this.authHeaders(token);
    }
    if (contentType) {
      baseHeaders['Content-Type'] = contentType;
    }
    return baseHeaders;
  };

  get(url, params, token = null) {
    return API({
      method: HttpMethod.Get,
      url,
      params,
      headers: token ? this.authHeaders(token) : baseHeaders,
    });
  }

  post(url, data, config = {}) {
    const {
      token, onUploadProgress, contentType, ...rest
    } = config;
    return API({
      method: HttpMethod.Post,
      url,
      data,
      headers: this.buildHeaders(token, contentType),
      onUploadProgress: onUploadProgress || null,
      ...rest,
    });
  }

  put(url, data, config = {}) {
    const { token, contentType } = config;
    return API({
      method: HttpMethod.Put,
      url,
      data,
      headers: this.buildHeaders(token, contentType),
    });
  }

  patch(url, data, token = null) {
    return API({
      method: HttpMethod.Patch,
      url,
      data,
      headers: token ? this.authHeaders(token) : baseHeaders,
    });
  }

  delete(url, params, token = null) {
    return API({
      method: HttpMethod.Delete,
      url,
      params,
      headers: token ? this.authHeaders(token) : baseHeaders,
    });
  }
}

export const httpService = new HttpService();
